import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { EditProfileDialogComponent } from './edit-profile-dialog.component';
import { GlobalState } from '../../../shared/global.state';
import { TeacherService } from '../../../shared/services/teacher.services';
import { UserService } from '../../../shared/services/user.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  user: any;
  constructor(
    public dialog: MatDialog,
    private _state: GlobalState,
    private teacherService:TeacherService,
    private userService:UserService
  ) { }

  ngOnInit() {
    this._state.watch('[User] UPDATE').subscribe((user) => {
      this.user = user;
    });

  }
  openDialogEditProfile(): void {
    const dialogRef = this.dialog.open(EditProfileDialogComponent, {
      width: '50%',
      data: {
        'user':this.user
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.teacherService.update(result).subscribe(()=>{
          ///...
        })
      }
    });
  }
  logout() {
    this.userService.logout();
  }
}
